import { route } from "@circle-react/lib/routes/define";

export const connectRoutes = {
  audienceOverview: route("/settings/audience/connect", {
    title: "Audience connect",
    requires: "admin",
    description:
      "Measure and manage member-to-member connections, including top connectors and recent connection activity.",
  }),

  communitySettings: route("/settings/connect", {
    title: "Connect settings",
    requires: "admin",
    description:
      "Community-level Circle Connect configuration — member-directory visibility, messaging defaults, and member-to-member discovery settings.",
  }),
};
